import React from "react";
import moment from 'moment';
import {WizTableForm} from '../../../common'

const contentConfig = WizTableForm.Config.content(this, {apiParams: {categoryCode: 'classAnnouncement', releaseState: 1,}});

//配置项
let componentName = 'classAnnouncement';

const columns = (self) => {
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      name: "classInfoId",
      formItem: {
        type: "hidden",
      }
    },
    {
      title: "公告名称",
      name: "title",
      searchItem: {},
      tableItem: {},
    },
    {
      title: "公告",
      name: "contentId",
      formItem: {
        ...contentConfig,
        diy: WizTableForm,
        // initRows: [],
        selectType: 'radio',
        rules: [
          {required: true, message: '请选择公告',},
        ],
        formatDynamicProps: (record) => {
          return {
            initRows: record?.contentId || record?.contentId === 0 ? [{id: record?.contentId, title: record?.title}] : []
          }
        }
      }
    },
    {
      title: "公告作者",
      name: "author",
      tableItem: {
        width: 120,
      },
    },
    {
      title: "公告状态",
      name: "releaseState",
      dict: [
        {code: 0, codeName: "草稿"},
        {code: 1, codeName: "已发布"},
        {code: 2, codeName: "取消发布"},
        {code: 3, codeName: "已关闭"},
      ],
      tableItem: {},
    },
    {
      title: "公告发布时间",
      name: "releaseTime",
      tableItem: {},
    },
    {
      title: "是否展示",
      name: "state",
      dict: [
        {code: 0, codeName: '无效'},
        {code: 1, codeName: '有效'},
      ],
      searchItem: {
        type: 'select'
      },
      tableItem: {},
      formItem: {
        type: "radio",
        initialValue: 1,
      },
    },
    {
      title: "顺序",
      name: "sort",
      tableItem: {},
      formItem: {
        type: 'number',
        placeholder: '请填写顺序，新增时不填写则默认填充',
        maxLength: 5,
      }
    },
  ]
};

const templateConfig = (self) => {
  let {pathname} = self
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(self),
        searchBarProps: {
          // cols: {
          //   xs: 24,
          //   md: 12,
          //   xl: 8
          // },
          buttonSort: ['add', 'export'],
          buttons: [
            {
              key: "export",
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
        },
        rowOperateSort: ['look', 'update'],
        rowOperateView: [
          {
            key: "look",
            custom: true,
            params: {children: "查看"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: pathname + "/lookClassInfo"
              }
            }
          },
        ],
        commonOperate: {
          add: true,
          delete: false,
          look: true
        }
      }
    }
  }
};

const apis = (self, data) => {
  let {classInfoId} = data

  return {
    list: {
      path: `${componentName}/getListByPage`,
      payload: {
        key: `${componentName}@getListByPage`,
        apiParams: {
          classInfoId
        }
      }
    },
    add: {
      path: `${componentName}/save`,
      payload: {
        key: `${componentName}@save`,
        apiParams: {
          classInfoId
        }
      }
    },
    update: {
      path: `${componentName}/upd`,
      payload: {
        key: `${componentName}@upd`,
        apiParams: {
        }
      }
    },
    delete: {
      path: `${componentName}/delete`,
      payload: {
        key: `${componentName}@delete`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {
          classInfoId
        }
      }
    },
  }
}


let reduxTemplateConfig = (self, args) => {
  return {
    apis: apis(self, args),
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    keepInitApiParams: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
